export default __webpack_public_path__ + "7a958da16b9a2208d792a0dce40ee84a.svg";